const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-vimeo-player'] = {
        c: () => require('partner/modules/moe-vimeo-player/moe-vimeo-player.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-vimeo-player',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-vimeo-player'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-vimeo-player|moe-vimeo-player'] = {
                c: () => require('partner/modules/moe-vimeo-player/moe-vimeo-player.view.tsx'),
                cn: '__local__-__local__-moe-vimeo-player'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };